import React from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import LinkIcon from '@material-ui/icons/Link';
import ExpireIcon from '@material-ui/icons/Alarm';
import BackupIcon from '@material-ui/icons/Backup';
import CalibrationIcon from '@material-ui/icons/Speed';
import ValidationIcon from '@material-ui/icons/CheckCircle';
import MaintanantIcon from '@material-ui/icons/Build';
import LogIcon from '@material-ui/icons/ListAlt';

import certifications from '../certifications';
import userslist from '../userslist';
import donors from '../donors';
import registration from '../registration';
import shipments from '../shipments';
import readyshipping from '../readyshipping';
import disposals from '../disposals';
import readydispose from '../readydispose';
import packings from '../packings';
import users from '../users';
import importexports from '../importexports';
import phleboto from '../phleboto';
import bleedLogs from '../bleedLogs';
import quarantine from '../quarantine';
import reports from '../deferralexp';
import sixmonths from '../sixmonths';
import noshow from '../noshow';
import Samples from '../samples';
import Sampleboxes from '../sampleBox';
import Downloads from '../downloads';
import Samplesextra from '../samples/extra';
import equipment from '../equipregister';
import logs from '../logs';
import lookback from '../lookback';
import reactive from '../reactive';
import cdcsdonations from '../cdcsdonations';
import chart from '../chart';
import appointmentResource from '../settings/AppointmentSettingResource';
import holidayResource from '../settings/HolidayResource';
import appointment from '../appointments/AppointmentResource';
import supplyinventory from '../supplyinventory';
import supplyshipments from '../supplyshipments';
import supplyadjustments from '../supplyadjustments';
import supplytypes from '../supplytypes';
import supplyvendors from '../supplyvendors';

/**
 * The whole navigation tree in one place.
 *
 * Menu.js (vertical sidebar) and TopMenu.js (horizontal bar) both render
 * from this, so a change to a link or a permission rule lands in both.
 *
 * buildMenu({ level, code, branch_code, userid }) -> [ section ]
 *   section = { key, name, icon, items: [ { key, to, label, icon } ] }
 *
 * Only sections the user may see are returned, already filtered, so the
 * renderers contain no permission logic at all.
 *
 * The level / code conditions below are carried over verbatim from the
 * original Menu.js, including its loose equality and its quirks - notably
 * the Certifications section, whose `level == 999` condition means it has
 * never rendered. It is kept so the two files stay honest about what the
 * app currently does; see the comment on that section.
 */

const f = (branch) => `filter=%7B"branch_code"%3A"${branch}"%7D`;

export const buildMenu = ({ level: rawLevel, code, branch_code, userid }) => {
    // The original used loose equality (`level != 99`), which tolerated a
    // string level coming back from the token. Coercing once here keeps the
    // strict comparisons below equivalent to the originals.
    const level = Number(rawLevel);
    const sections = [];
    const push = (visible, section) => { if (visible) { sections.push(section); } };

    /* ----------------------------- Donors ----------------------------- */

    push(
        level > 1.5 && level !== 99 && level !== 9
            && code !== 'PHLE' && code !== 'PLAP' && code !== 'DONP',
        {
            key: 'menuDonors',
            name: 'Donors',
            icon: donors.icon,
            items: [
                { key: 'donors', to: '/donors?', label: 'List', icon: donors.icon },
                {
                    key: 'registration',
                    to: `/registration?${f(branch_code)}&order=ASC&page=1&perPage=25&sort=name`,
                    label: 'Registration',
                    icon: registration.icon,
                    visible: code !== 'PLAP' && code !== 'PHLE',
                },
                {
                    key: 'appointments',
                    to: '/appointment/appointments',
                    label: 'Appointments',
                    icon: appointment.icon,
                },
            ],
        }
    );

    push(code === 'DONP', {
        key: 'menuDonors',
        name: 'Donors',
        icon: donors.icon,
        items: [
            {
                key: 'donors',
                to: '/donors?filter=%7B"code"%3A"DONP"%7D&order=ASC&page=1&perPage=25&sort=name',
                label: 'List',
                icon: donors.icon,
            },
        ],
    });

    /* ----------------------------- Samples ---------------------------- */

    push(
        level > 2 && level !== 9
            && code !== 'PHYN' && code !== 'PHYS' && code !== 'PHLE' && code !== 'QA',
        {
            key: 'menuSamples',
            name: 'Samples',
            icon: Samples.icon,
            items: [
                { key: 'create', to: '/Samplesextra/create', label: 'Create', icon: Samplesextra.icon },
                {
                    key: 'list',
                    to: `/samples?${f(branch_code)}&order=DESC&page=1&perPage=25`,
                    label: 'List',
                    icon: Samples.icon,
                },
                {
                    key: 'boxes',
                    to: `/sampleboxes/?${f(branch_code)}&order=DESC&page=1&perPage=25`,
                    label: 'Boxes',
                    icon: Sampleboxes.icon,
                },
                { key: 'downloads', to: '/Downloads/create', label: 'Downloads', icon: Downloads.icon },
            ],
        }
    );

    push((code === 'PHYN' || code === 'PHYS' || code === 'QA') && level !== 9, {
        key: 'menuSamples',
        name: 'Samples',
        icon: Samples.icon,
        items: [
            { key: 'downloads', to: '/Downloads/create', label: 'Downloads', icon: Downloads.icon },
        ],
    });

    /* ---------------------------- Shipping ---------------------------- */

    push(level > 5 && level !== 99 && level !== 9, {
        key: 'menuShipping',
        name: 'Shipping',
        icon: shipments.icon,
        items: [
            { key: 'packings', to: `/packings?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Packing', icon: packings.icon },
            { key: 'readyshipping', to: `/readyshipping?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Ready To Ship', icon: readyshipping.icon },
            { key: 'shipments', to: `/shipments?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Shipments', icon: shipments.icon },
            { key: 'readydispose', to: `/readydispose?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Ready To Dispose', icon: readydispose.icon },
            { key: 'disposals', to: `/disposals?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Disposed', icon: disposals.icon },
        ],
    });

    /* -------------------------- Certifications ------------------------
     * NOTE: the original condition is `level > 1.5 && level != 99 && level == 999`,
     * which cannot be satisfied - level is never 999. This section has therefore
     * never appeared in the sidebar. Preserved as-is rather than silently
     * enabling a section nobody has seen; change 999 to a real level to turn it on.
     * ------------------------------------------------------------------ */

    push(level > 1.5 && level !== 99 && level === 999, {
        key: 'menuCertifications',
        name: 'Certifications',
        icon: certifications.icon,
        items: [
            {
                key: 'certifications',
                to: `/Certifications?filter=%7B"user_id"%3A"${userid}"%7D&order=ASC&page=1&perPage=25&sort=training_name`,
                label: 'Certtifications',
                icon: certifications.icon,
            },
            {
                key: 'userslist',
                to: '/userslist',
                label: 'Users',
                icon: userslist.icon,
                visible: level > 6 && level !== 99,
            },
        ],
    });

    /* ----------------------------- Reports ----------------------------
     * Four mutually exclusive variants, by role. Same section name, so at
     * most one is ever visible at a time.
     * ------------------------------------------------------------------ */

    push(level > 6 && level !== 99 && level !== 9, {
        key: 'menuReports',
        name: 'Reports',
        icon: reports.icon,
        items: [
            { key: 'deferralexp', to: '/deferralexp', label: 'Def Expire', icon: ExpireIcon },
            { key: 'sixmonths', to: '/sixmonths', label: 'New Donors', icon: sixmonths.icon },
            { key: 'noshow', to: '/noshow', label: 'No show', icon: noshow.icon },
            { key: 'lookback', to: `/lookback?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Lookback', icon: lookback.icon },
            { key: 'bleedLogs', to: `/bleedLogs?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Bleed Logs', icon: bleedLogs.icon },
            { key: 'phleboto', to: `/phleboto?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Phleboto Logs', icon: phleboto.icon },
            { key: 'quarantine', to: `/quarantine?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Quarantine Logs', icon: quarantine.icon },
            { key: 'reactive', to: `/reactive?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Reactive Logs', icon: reactive.icon },
            { key: 'logs', to: `/logs?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'System Logs', icon: logs.icon },
            { key: 'cdcsdonations', to: `/cdcsdonations?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'CDCS uploads', icon: cdcsdonations.icon },
            { key: 'chart', to: '/chart', label: 'Analytics', icon: chart.icon },
        ],
    });

    // level 9 uses `branch` rather than `branch_code` in its filters
    const b = (branch) => `filter=%7B"branch"%3A"${branch}"%7D`;

    push(level === 9, {
        key: 'menuReports',
        name: 'Reports',
        icon: reports.icon,
        items: [
            { key: 'deferralexp', to: `/deferralexp?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Def Expire', icon: ExpireIcon },
            { key: 'sixmonths', to: `/sixmonths?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'New Donors', icon: sixmonths.icon },
            { key: 'noshow', to: `/noshow?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'No show', icon: noshow.icon },
            { key: 'lookback', to: `/lookback?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Lookback', icon: lookback.icon },
            { key: 'bleedLogs', to: `/bleedLogs?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Bleed Logs', icon: bleedLogs.icon },
            { key: 'phleboto', to: `/phleboto?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Phleboto Logs', icon: phleboto.icon },
            { key: 'quarantine', to: `/quarantine?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Quarantine Logs', icon: quarantine.icon },
            { key: 'reactive', to: `/reactive?${b(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Reactive Logs', icon: reactive.icon },
            { key: 'logs', to: `/logs?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'System Logs', icon: logs.icon },
            { key: 'cdcsdonations', to: '/cdcsdonations', label: 'CDCS uploads', icon: cdcsdonations.icon },
            { key: 'chart', to: '/chart', label: 'Analytics', icon: chart.icon },
        ],
    });

    push(code === 'PLAP', {
        key: 'menuReports',
        name: 'Reports',
        icon: reports.icon,
        items: [
            { key: 'bleedLogs', to: `/bleedLogs?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Bleed Logs', icon: bleedLogs.icon },
            { key: 'quarantine', to: `/quarantine?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Quarantine Logs', icon: quarantine.icon },
            { key: 'reactive', to: `/reactive?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Reactive Logs', icon: reactive.icon },
        ],
    });

    push(code === 'PHYN' || code === 'PHYS', {
        key: 'menuReports',
        name: 'Reports',
        icon: reports.icon,
        items: [
            { key: 'reactive', to: `/reactive?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Reactive Logs', icon: reactive.icon },
        ],
    });

    push(code === 'PHLE', {
        key: 'menuReports',
        name: 'Reports',
        icon: reports.icon,
        items: [
            { key: 'phleboto', to: `/phleboto?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Phleboto Logs', icon: phleboto.icon },
        ],
    });

    /* --------------------------- Instruments -------------------------- */

    push(level > 1.5 && level !== 99 && level !== 9 && code !== 'PHYN' && code !== 'PHYS', {
        key: 'menuInsruments',
        name: 'Instruments',
        icon: equipment.icon,
        items: [
            { key: 'cal', to: `/calinstrument?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Calibration', icon: CalibrationIcon },
            { key: 'val', to: `/valinstrument?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Validation', icon: ValidationIcon },
            { key: 'mai', to: `/maiinstrument?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Maintenance', icon: MaintanantIcon },
            { key: 'log', to: `/loginstrument?${f(branch_code)}&order=DESC&page=1&perPage=25`, label: 'Log', icon: LogIcon },
        ],
    });

    /* ---------------------------- Inventory --------------------------- */

    push(level > 1.5 && level !== 99 && level !== 9 && code !== 'PHYN' && code !== 'PHYS', {
        key: 'menuInventory',
        name: 'Inventory',
        icon: supplyinventory.icon,
        items: [
            {
                key: 'soft',
                to: '/supplyinventory?filter=%7B"category_id"%3A1%7D&order=ASC&page=1&perPage=25&sort=supply_type',
                label: 'Donation Softgoods',
                icon: supplyinventory.icon,
            },
            {
                key: 'cal',
                to: '/supplyinventory?filter=%7B"category_id"%3A2%7D&order=ASC&page=1&perPage=25&sort=supply_type',
                label: 'Calibration Supplies',
                icon: CalibrationIcon,
            },
            {
                key: 'shipments',
                to: '/supplyshipments?filter=%7B"status"%3A"FINALIZED"%7D&order=DESC&page=1&perPage=25&sort=receipt_date',
                label: 'Supply Shipments',
                icon: supplyshipments.icon,
            },
            { key: 'newshipment', to: '/supplyshipments/create', label: 'New Supply Shipment', icon: BackupIcon },
            {
                key: 'adjustments',
                to: '/supplyadjustments?order=DESC&page=1&perPage=25&sort=adj_datetime',
                label: 'Adjustment History',
                icon: supplyadjustments.icon,
            },
            // Supply Types and Vendors live under Administration, not here
        ],
    });

    /* -------------------------- Administration ------------------------ */

    push(level > 7 && level !== 99 && level !== 9, {
        key: 'menuAdmin',
        name: 'Administration',
        icon: SettingsIcon,
        items: [
            { key: 'users', to: `/users?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Users', icon: users.icon },
            { key: 'shippingdoc', to: `/importexports?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Shipping Doc', icon: importexports.icon },
            { key: 'uploads', to: '/importexports/create', label: 'Uploads', icon: BackupIcon },
            { key: 'instruments', to: `/instruments?${f(branch_code)}&order=DESC&page=1&perPage=25&sort=id`, label: 'Instruments', icon: equipment.icon },
            { key: 'supplytypes', to: '/supplytypes?order=ASC&page=1&perPage=25&sort=name', label: 'Supply Types', icon: supplytypes.icon },
            { key: 'supplyvendors', to: '/supplyvendors?order=ASC&page=1&perPage=25&sort=name', label: 'Vendors', icon: supplyvendors.icon },
            { key: 'apptsettings', to: '/appointment/appointment-settings', label: 'Appointment Settings', icon: appointmentResource.icon },
            { key: 'holidays', to: '/appointment/holidays', label: 'Holiday Management', icon: holidayResource.icon },
        ],
    });

    /* ------------------------------ Links ------------------------------
     * External sites - rendered as plain anchors, not router links.
     * ------------------------------------------------------------------ */

    push(level > 1 && level !== 99, {
        key: 'menuLinks',
        name: 'Links',
        icon: LinkIcon,
        external: true,
        items: [
            { key: 'nddr', url: 'https://www.nddrandcdcs.org/Account/Login', label: 'NDDR | CDCS' },
            { key: '3pea', url: 'https://share.3pea.net/login', label: '3PEA' },
        ],
    });

    // drop any item hidden by its own predicate, then any section left empty
    return sections
        .map(s => Object.assign({}, s, {
            items: s.items.filter(i => i.visible === undefined || i.visible),
        }))
        .filter(s => s.items.length > 0);
};

/** Whether the Dashboard entry shows, using the original condition. */
export const showDashboard = ({ level }) => Number(level) > 1 && Number(level) !== 99;

/** Whether the company logo shows above the menu. */
export const showLogo = ({ level }) => Number(level) > 1;

export default buildMenu;
